import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=06b44220&scoped=true"
import script from "./SwitchInput.vue?vue&type=script&lang=js"
export * from "./SwitchInput.vue?vue&type=script&lang=js"
import style0 from "./SwitchInput.vue?vue&type=style&index=0&id=06b44220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b44220",
  null
  
)

export default component.exports